import type { Id } from '@hq/utils';
import type { HttpClient } from '../client';
import type {
  AttachmentDto,
  BindFileResult,
  DeleteFileResult,
  SignedUrlDto,
  UploadFileOptions
} from '../types/file';

const BASE = '/files';

/** 影像/附件（Hq.Res.Api，独立服务与独立 baseUrl）。path 相对 resBaseUrl（含 `/res` 段）。 */
export function createFileApi(http: HttpClient) {
  return {
    /** multipart 上传；成功返回裸对象（无 ApiResult 包装），秒传命中时 reused=true。 */
    upload(options: UploadFileOptions): Promise<AttachmentDto> {
      const form = new FormData();
      const name = options.fileName ?? (options.file as { name?: string }).name ?? 'file';
      form.append('file', options.file, name);
      if (options.orgId) form.append('orgId', options.orgId);
      if (options.bizType) form.append('bizType', options.bizType);
      if (options.bizId) form.append('bizId', options.bizId);
      if (options.bizNo) form.append('bizNo', options.bizNo);
      if (options.bizField) form.append('bizField', options.bizField);
      if (options.isPublic !== undefined) form.append('isPublic', options.isPublic ? '1' : '0');
      if (options.source) form.append('source', options.source);
      if (options.shootAt) form.append('shootAt', options.shootAt);
      if (options.geoPoint) form.append('geoPoint', options.geoPoint);
      // 宽高/时长由客户端测量（资源服务只入库，不做图像处理）
      if (options.width) form.append('width', String(options.width));
      if (options.height) form.append('height', String(options.height));
      if (options.durationMs) form.append('durationMs', String(options.durationMs));
      // 临时附件到期：仅服务身份生效（客户端传了也会被服务端忽略）
      if (options.expireAt) form.append('expireAt', options.expireAt);

      return http.request<AttachmentDto>({ path: BASE, method: 'POST', form });
    },

    /** 刷新签名直链（过期后用）。 */
    signedUrl(id: Id): Promise<SignedUrlDto> {
      return http.request<SignedUrlDto>({ path: `${BASE}/${id}/url` });
    },

    bind(id: Id, body: { bizType: string; bizId: Id; bizNo?: string; bizField?: string }): Promise<BindFileResult> {
      return http.request<BindFileResult>({ path: `${BASE}/${id}/bind`, method: 'POST', body });
    },

    remove(id: Id): Promise<DeleteFileResult> {
      return http.request<DeleteFileResult>({ path: `${BASE}/${id}`, method: 'DELETE' });
    }
  };
}

export type FileApi = ReturnType<typeof createFileApi>;
